module.exports = __webpack_public_path__ + "img/tijian_img1.379427d0.png";